import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const STORAGE_NAME = 'ambassador-code'

type AmbassadorCodeState = {
  ambassadorCode: string | undefined
  setAmbassadorCode: (code: string) => void
  removeAmbassadorCode: () => void
}

/**
 * Persisted ambassador referral code captured from a public `/ambassador/:code`
 * link. Read on the register page (preview) and prefilled on my-ambassador.
 */
export const useAmbassadorCodeStore = create<AmbassadorCodeState>()(
  persist(
    (set) => ({
      ambassadorCode: undefined,
      setAmbassadorCode: (code) => set({ ambassadorCode: code }),
      removeAmbassadorCode: () => {
        set({ ambassadorCode: undefined })
        localStorage.removeItem(STORAGE_NAME)
      },
    }),
    {
      name: STORAGE_NAME,
    }
  )
)
